export default __webpack_public_path__ + "3ed637bca9ed38b0c55cdbd9abcd9598.svg";